<template>
    <div>
        <ShopCart></ShopCart>
    </div>
</template>

<script>
import ShopCart from '../components/shopcart/ShopCart';

export default {
    name: 'shopcart',
    components: {
        ShopCart,
    },
};
</script>

<style lang="less" scoped>
</style>